import React from 'react';
import styles from './Alert.module.css';

export default function Alert({ type = 'error', children }) {
  if (!children) return null;
  return (
    <div className={[styles.alert, styles[type]].join(' ')} role="alert">
      {children}
    </div>
  );
}
